(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bike-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('[data-bpdp]');
    if (!root || !window.__bpdpProduct) return;
    const productData = window.__bpdpProduct;
    const ADD_LABEL = 'Add to Cart - In-stock Ships within 24hr';

    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const optionInputs = root.querySelectorAll('[data-bpdp-option]');
    const variantIdInput = root.querySelector('[data-bpdp-variant-id]');
    const priceEl = root.querySelector('[data-bpdp-price]');
    const compareEl = root.querySelector('[data-bpdp-compare-at]');
    const addBtn = root.querySelector('[data-bpdp-add]');
    const addLabel = root.querySelector('[data-bpdp-add-label]');
    const mainImg = root.querySelector('[data-bpdp-main-img]');
    const optionValueEls = root.querySelectorAll('[data-bpdp-option-value]');
    const thumbs = root.querySelectorAll('[data-bpdp-thumb]');

    // Returns just the pathname of a CDN URL for comparison, stripping all query params.
    function imgPath(url) {
      if (!url) return '';
      try { return new URL(url.startsWith('//') ? 'https:' + url : url).pathname; }
      catch (e) { return url.split('?')[0]; }
    }

    function getSelectedOptions() {
      const opts = {};
      optionInputs.forEach(input => { if (input.checked) opts[input.dataset.optionPosition] = input.value; });
      return opts;
    }
    function findVariant(opts) {
      return productData.variants.find(v =>
        Object.keys(opts).every(pos => v['option' + pos] === opts[pos])
      );
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);

      optionValueEls.forEach(el => {
        const pos = el.dataset.bpdpOptionValue;
        if (opts[pos]) el.textContent = opts[pos];
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Unavailable'; }
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = variant.id;
        // Dispatch a change event so Timesact (and other app integrations) know
        // the variant has switched. Without this, apps that listen to
        // change on [name="id"] never re-evaluate the new variant's pre-order status.
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.querySelector('s').textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        // Re-query from live DOM — Timesact may have replaced addBtn.innerHTML,
        // making the cached addLabel reference a detached (invisible) node.
        const liveLabel = addBtn.querySelector('[data-bpdp-add-label]');
        if (liveLabel) {
          liveLabel.textContent = variant.available ? ADD_LABEL : 'Sold out';
        } else {
          // Timesact replaced innerHTML — rebuild the span so our downstream
          // JS (applyPreorderState, syncSticky) can find it again.
          addBtn.innerHTML = '<span data-bpdp-add-label data-add-to-cart-text>' +
            (variant.available ? ADD_LABEL : 'Sold out') + '</span>';
        }
      }

      if (variant.featured_image && mainImg) {
        const newSrc = variant.featured_image.src;
        if (newSrc) {
          mainImg.src = newSrc.startsWith('//') ? 'https:' + newSrc : newSrc;
          mainImg.removeAttribute('srcset');
          // Activate the thumbnail whose image matches this variant
          const newPath = imgPath(newSrc);
          thumbs.forEach(function(t) {
            t.classList.toggle('is-active', !!newPath && imgPath(t.dataset.imageSrc) === newPath);
          });
        }
      }

      updateAddTotal();
    }

    optionInputs.forEach(input => input.addEventListener('change', updateVariant));

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.imageSrc;
          mainImg.srcset = thumb.dataset.imageSrcset;
        }
        // If this image is a variant's featured image, select that variant.
        // radio.click() will trigger updateVariant() which will also update the
        // main image (from featured_image.src) and re-sync the active thumb.
        const thumbPath = imgPath(thumb.dataset.imageSrc);
        const matchingVariant = productData.variants.find(function(v) {
          return v.featured_image && imgPath(v.featured_image.src) === thumbPath;
        });
        if (matchingVariant && matchingVariant.option1) {
          const radio = root.querySelector('input[type="radio"][value="' + CSS.escape(matchingVariant.option1) + '"]');
          if (radio && !radio.checked) radio.click();
        }
      });
    });

    const qtyInput = root.querySelector('[data-bpdp-qty-input]');
    root.querySelectorAll('[data-bpdp-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.bpdpQty, 10));
        qtyInput.value = next;
        updateAddTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateAddTotal);

    const addons = root.querySelectorAll('[data-bpdp-addon]');
    const addTotalEl = root.querySelector('[data-bpdp-add-total]');
    const addonsCountEl = root.querySelector('[data-bpdp-addons-count]');

    function updateAddonsCount() {
      if (!addonsCountEl) return;
      let count = 0;
      addons.forEach(cb => { if (cb.checked) count++; });
      if (count > 0) {
        addonsCountEl.textContent = count + ' selected';
        addonsCountEl.hidden = false;
      } else {
        addonsCountEl.hidden = true;
      }
    }

    function updateAddTotal() {
      if (!addTotalEl) return;
      const cv = productData.variants.find(v => v.id == (variantIdInput && variantIdInput.value)) || productData.variants[0];
      const qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      let total = (cv ? cv.price : 0) * qty;
      let count = 0;
      addons.forEach(cb => {
        if (cb.checked) {
          total += parseInt(cb.dataset.price, 10);
          count++;
        }
      });
      const countLabel = count > 0 ? ' + ' + count : '';
      addTotalEl.textContent = '— ' + formatMoney(total) + countLabel;
      updateAddonsCount();
    }
    addons.forEach(cb => cb.addEventListener('change', updateAddTotal));

    /* ----------------------------------------------------------
       Per-addon variant pickers (colour / size / etc).
       Each <li.bpdp__addon> may contain a <script
       data-bpdp-addon-variants> JSON blob plus radio inputs
       [data-bpdp-addon-option]. When the user picks options we:
        - re-find the matching variant
        - update the checkbox's data-variant-id and data-price
        - update the displayed price
        - if the picked combo is OOS: force-uncheck, disable,
          show the "Temporarily unavailable" label
        - grey out option values that have no in-stock combo
          given the other currently-selected options
       ---------------------------------------------------------- */
    root.querySelectorAll('[data-bpdp-addon]').forEach(cb => {
      const li = cb.closest('.bpdp__addon');
      if (!li) return;
      const dataEl = li.querySelector('script[data-bpdp-addon-variants]');
      if (!dataEl) return; // No variant picker on this addon — single-variant product.

      let variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!Array.isArray(variants) || variants.length === 0) return;

      const optionInputs = Array.from(li.querySelectorAll('[data-bpdp-addon-option]'));
      const priceEl = li.querySelector('[data-bpdp-addon-price]');
      const oosEl   = li.querySelector('[data-bpdp-addon-oos]');

      function readOpts() {
        const opts = {};
        optionInputs.forEach(input => {
          if (input.checked) opts[input.dataset.optionPosition] = input.value;
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(v =>
          Object.keys(opts).every(pos => v['option' + pos] === opts[pos])
        );
      }

      function greyOutValues() {
        const currentOpts = readOpts();
        optionInputs.forEach(input => {
          const pos = input.dataset.optionPosition;
          const test = Object.assign({}, currentOpts);
          test[pos] = input.value;
          const match = variants.find(v =>
            Object.keys(test).every(p => v['option' + p] === test[p])
          );
          const ok = !!(match && match.available);
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
          // Don't disable the input — let users tap it to surface the OOS state
          // on the main row. Greying is enough of a signal.
        });
      }

      function update() {
        const variant = findVariant(readOpts());

        if (!variant) {
          // No matching variant at all — treat as unavailable.
          cb.checked = false;
          cb.disabled = true;
          cb.dataset.variantId = '';
          cb.dataset.price = '0';
          li.classList.add('bpdp__addon--oos');
          if (oosEl) oosEl.hidden = false;
        } else {
          cb.dataset.variantId = String(variant.id);
          cb.dataset.price = String(variant.price);
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (variant.available) {
            cb.disabled = false;
            li.classList.remove('bpdp__addon--oos');
            if (oosEl) oosEl.hidden = true;
          } else {
            cb.checked = false;
            cb.disabled = true;
            li.classList.add('bpdp__addon--oos');
            if (oosEl) oosEl.hidden = false;
          }
        }

        greyOutValues();
        updateAddTotal();
      }

      optionInputs.forEach(input => input.addEventListener('change', update));
      update(); // initial sync
    });

    updateAddTotal();

    // Preorder detection — read button text fresh from DOM each time,
    // because Timesact replaces the button's innerHTML and our cached
    // span references go stale.
    function isPreorderActive() {
      if (!addBtn) return false;
      if (addBtn.dataset.preorder === 'true') return true;
      if (addBtn.hasAttribute('data-timesact-preorder')) return true;
      const t = (addBtn.textContent || '').toLowerCase();
      return t.indexOf('pre-order') !== -1 || t.indexOf('preorder') !== -1 || t.indexOf('notify') !== -1;
    }

    // Preorder unification — instead of moving Timesact's element into our button
    // (which fights its own internal positioning), we read its message text and
    // inject it as a plain second line inside our button, then hide the original.
    const actionsEl = root.querySelector('.bpdp__actions');

    // Timesact config — read the arrival date straight from the app's config
    // so the second line doesn't depend on Timesact rendering its own message.
    let timesactVariants = null;
    fetch('/apps/timesact/config?productId=' + productData.id)
      .then(r => r.ok ? r.json() : null)
      .then(d => { timesactVariants = (d && d.product && d.product.variants) || null; debouncedApply(); })
      .catch(() => {});

    function timesactArrivalText() {
      if (!timesactVariants || !variantIdInput) return '';
      const v = timesactVariants[String(variantIdInput.value)];
      const sd = v && v.config && v.config.status === 'ACTIVE' && v.config.shippingDate;
      if (!sd || sd.type === 'NO_SET' || !sd.date) return '';
      const d = new Date(sd.date * 1000);
      if (d < new Date()) return '';
      return 'STOCK ARRIVAL ' + d.toLocaleDateString('en-AU', {
        timeZone: 'Australia/Hobart', day: 'numeric', month: 'short', year: 'numeric'
      }).toUpperCase();
    }

    function findTimesactMessageText() {
      const sel = '[class*="timesact" i], [id*="timesact" i], [data-timesact], ' +
                  '[class*="dispatch" i], [class*="preorder" i], [class*="pre-order" i], ' +
                  '[class*="arrival" i]';
      const KEYWORDS = /(arriv|dispatch|ship|deliver|stock|expected|available)/;
      let best = null;
      document.querySelectorAll(sel).forEach(el => {
        if (addBtn && (el === addBtn || el.contains(addBtn))) return;
        if (el.closest('[data-bpdp-cta-subline], [data-bpdp-sticky], [data-bpdp-add-total-line], [data-bpdp-addons]')) return;
        const txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (txt.length < 3 || txt.length > 160) return;
        if (!KEYWORDS.test(txt.toLowerCase())) return;
        const hasDate = /\d/.test(txt);
        if (!best ||
            (hasDate && !best.hasDate) ||
            (hasDate === best.hasDate && txt.length < best.text.length)) {
          best = { text: txt, element: el, hasDate: hasDate };
        }
      });
      return best;
    }

    function applyPreorderState() {
      const totalLine = root.querySelector('[data-bpdp-add-total-line]');
      const subline = root.querySelector('[data-bpdp-cta-subline]');
      const preorder = isPreorderActive();

      if (totalLine) {
        if (preorder) totalLine.setAttribute('hidden', '');
        else totalLine.removeAttribute('hidden');
      }
      if (!actionsEl) return;
      actionsEl.classList.toggle('is-preorder', preorder);

      if (preorder && subline) {
        const arrival = timesactArrivalText();
        const found = arrival ? null : findTimesactMessageText();
        const next = arrival || ((found && found.text) ? found.text : 'Pre-order — ships when in stock');
        if (subline.textContent !== next) subline.textContent = next;
        subline.removeAttribute('hidden');
      } else if (subline) {
        subline.setAttribute('hidden', '');
      }

      if (subline && !subline.dataset.bpdpHooked) {
        subline.dataset.bpdpHooked = 'true';
        const trigger = () => { if (addBtn && !addBtn.disabled) addBtn.click(); };
        subline.addEventListener('click', trigger);
        subline.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger(); }
        });
      }
    }
    const hideTotalIfPreorder = applyPreorderState;

    let lastKey = '';
    let debounceTimer = null;
    function debouncedApply() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const btnText = addBtn ? (addBtn.textContent || '').trim() : '';
        const found = isPreorderActive() ? findTimesactMessageText() : null;
        const key = btnText + '|' + (found ? found.text : '') + '|' + timesactArrivalText() + '|' + (variantIdInput ? variantIdInput.value : '');
        if (key === lastKey) return;
        lastKey = key;
        applyPreorderState();
      }, 100);
    }

    if ('MutationObserver' in window) {
      if (addBtn) {
        new MutationObserver(debouncedApply)
          .observe(addBtn, { childList: true, subtree: true, characterData: true });
      }
      new MutationObserver(debouncedApply)
        .observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    [200, 500, 1000, 2000, 3500, 5000, 8000, 12000].forEach(ms => setTimeout(debouncedApply, ms));

    const form = root.querySelector('[data-bpdp-form]');
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (addBtn && addBtn.disabled) {
          e.preventDefault();
          return;
        }

        // Preorder products — the native form post to /cart/add owns the bike line
        // (keeps Timesact's hidden properties). Add-on checkboxes have no `name`,
        // so a native post only carries the bike. If add-ons are ticked, add them
        // via AJAX first, then hand off to the native post.
        if (isPreorderActive()) {
          const preorderAddons = [];
          addons.forEach(cb => {
            const vid = parseInt(cb.dataset.variantId, 10);
            if (cb.checked && !cb.disabled && vid) preorderAddons.push({ id: vid, quantity: 1 });
          });
          if (!preorderAddons.length) return; // nothing extra — native submit as before

          e.preventDefault();
          if (addBtn) addBtn.disabled = true;
          try {
            const r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: preorderAddons })
            });
            if (!r.ok) {
              const err = await r.json().catch(() => ({}));
              throw new Error(err.description || 'Could not add extras to cart');
            }
          } catch (err) {
            if (addBtn) addBtn.disabled = false;
            alert(err.message);
            return;
          }
          if (addBtn) addBtn.disabled = false;
          HTMLFormElement.prototype.submit.call(form); // native post, skips this handler
          return;
        }

        e.preventDefault();
        const items = [{
          id: parseInt(variantIdInput.value, 10),
          quantity: parseInt(qtyInput.value, 10) || 1
        }];
        addons.forEach(cb => {
          const vid = parseInt(cb.dataset.variantId, 10);
          if (cb.checked && !cb.disabled && vid) items.push({ id: vid, quantity: 1 });
        });
        const originalLabel = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = 'Adding…';
        if (addBtn) addBtn.disabled = true;

        try {
          if (window.ZippiCart && typeof window.ZippiCart.addAndOpen === 'function') {
            await window.ZippiCart.addAndOpen(items);
            if (addLabel) addLabel.textContent = 'Added';
            setTimeout(() => {
              if (addLabel) addLabel.textContent = originalLabel;
              if (addBtn) addBtn.disabled = false;
            }, 1500);
          } else {
            // Fallback if cart.js failed to load
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) {
              const err = await response.json();
              throw new Error(err.description || 'Could not add to cart');
            }
            window.location.href = '/cart';
          }
        } catch (err) {
          if (addLabel) addLabel.textContent = originalLabel;
          if (addBtn) addBtn.disabled = false;
          alert(err.message);
        }
      });
    }

    /* ----------------------------------------------------------
       Sticky mobile add-to-cart bar.
       - Visible only ≤900px (CSS handles the breakpoint)
       - Shown only when the main .bpdp__cta is OFF-screen
       - Mirrors price + label from the main CTA
       - Clicking forwards to the main CTA so all existing
         submit / preorder logic continues to work unchanged.
       ---------------------------------------------------------- */
    const stickyBar    = root.querySelector('[data-bpdp-sticky]');
    const stickyAddBtn = root.querySelector('[data-bpdp-sticky-add]');
    const stickyLabel  = root.querySelector('[data-bpdp-sticky-label]');
    const stickyPrice  = root.querySelector('[data-bpdp-sticky-price]');

    function syncSticky() {
      if (!stickyAddBtn || !addBtn) return;
      stickyAddBtn.disabled = addBtn.disabled;
      if (stickyLabel && addLabel) {
        // The long in-stock label doesn't fit the small sticky button — shorten it.
        const t = (addLabel.textContent || '').trim();
        stickyLabel.textContent = (t === ADD_LABEL) ? 'Add to cart' : t;
      }
      if (stickyPrice && priceEl) {
        stickyPrice.textContent = priceEl.textContent;
      }
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (addBtn && !addBtn.disabled) addBtn.click();
      });
    }

    // IntersectionObserver — show sticky bar only when main CTA is out of view.
    // Also lifts the Shopify Inbox chat button above the bar while it's showing.
    const CHAT_SEL = 'shopify-chat';
    let stickyOn = false;

    function chatEls() {
      const out = [];
      document.querySelectorAll(CHAT_SEL).forEach(el => {
        if (getComputedStyle(el).position === 'fixed') out.push(el);
        if (el.shadowRoot) {
          el.shadowRoot.querySelectorAll('*').forEach(c => {
            if (getComputedStyle(c).position === 'fixed') out.push(c);
          });
        }
      });
      return out;
    }

    function placeChat() {
      if (!stickyBar) return;
      const lift = stickyOn && window.matchMedia('(max-width: 900px)').matches;
      chatEls().forEach(el => {
        if (!('bpdpOrig' in el.dataset)) {
          el.dataset.bpdpOrig = el.style.getPropertyValue('bottom');
          el.dataset.bpdpOrigPx = parseFloat(getComputedStyle(el).bottom) || 0;
        }
        if (lift) {
          const px = parseFloat(el.dataset.bpdpOrigPx) + stickyBar.offsetHeight + 8;
          el.style.setProperty('bottom', px + 'px', 'important');
        } else if (el.dataset.bpdpOrig) {
          el.style.setProperty('bottom', el.dataset.bpdpOrig);
        } else {
          el.style.removeProperty('bottom');
        }
      });
    }

    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          stickyOn = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', stickyOn);
          stickyBar.setAttribute('aria-hidden', stickyOn ? 'false' : 'true');
          placeChat();
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(addBtn);

      // Inbox loads after the page — re-apply when it injects itself.
      new MutationObserver(placeChat).observe(document.body, { childList: true });
      window.addEventListener('resize', placeChat);
    }

    // Keep sticky state in sync as variants / price / availability change.
    if (addBtn && 'MutationObserver' in window) {
      const stickyObserver = new MutationObserver(syncSticky);
      stickyObserver.observe(addBtn, { attributes: true, childList: true, subtree: true });
    }
    // Initial sync + a couple of delayed syncs to catch async app updates.
    syncSticky();
    [300, 1000, 2500].forEach(ms => setTimeout(syncSticky, ms));

    /* ----------------------------------------------------------
       Auto-select first in-stock variant on page load.
       Problem: the page defaults to the first variant alphabetically,
       which may be an out-of-stock variant that Timesact has set to
       ACTIVE pre-order. Customers then see "Pre-order This Product"
       even though other colours are available to buy immediately.
       Fix: fetch Timesact's config, check if the default variant is
       ACTIVE, and silently switch to the first PENDING (in-stock) one.
    ---------------------------------------------------------- */
    (async function autoSelectInStockVariant() {
      try {
        const resp = await fetch('/apps/timesact/config?productId=' + productData.id);
        const data = await resp.json();
        if (!data.product || !data.product.variants) return;

        const currentId = String(variantIdInput ? variantIdInput.value : (productData.variants[0] && productData.variants[0].id));
        const currentCfg = data.product.variants[currentId];
        // Only act if the default-selected variant is actively in pre-order mode
        if (!currentCfg || !currentCfg.config || currentCfg.config.status !== 'ACTIVE') return;

        // Find the first PENDING (genuinely in-stock) variant
        const pendingEntry = Object.entries(data.product.variants)
          .find(function(entry) { return entry[1].config && entry[1].config.status === 'PENDING'; });
        if (!pendingEntry) return;

        const pendingVariant = productData.variants.find(function(v) { return String(v.id) === pendingEntry[0]; });
        if (!pendingVariant || !pendingVariant.option1) return;

        // Click the matching colour radio — this triggers the full updateVariant() flow
        // including the change event dispatch that Timesact listens to.
        const radio = root.querySelector('input[type="radio"][value="' + CSS.escape(pendingVariant.option1) + '"]');
        if (radio && !radio.checked) radio.click();
      } catch (e) {
        // Silent fail — don't break the page if Timesact's config is unavailable
      }
    })();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bike-pdp-unboxing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var triggers = document.querySelectorAll('[data-unbox-trigger]');
    triggers.forEach(function (trig) {
      function load () {
        var embed = trig.getAttribute('data-embed');
        if (!embed) return;
        var iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
        iframe.setAttribute('title', 'Unboxing video');
        var player = trig.closest('[data-unbox-player]');
        if (player) {
          player.innerHTML = '';
          player.appendChild(iframe);
        }
      }
      trig.addEventListener('click', load);
      trig.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); load(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('[data-cart-main]');
    if (!root) return;

    function changeLine(key, qty, btn) {
      if (btn) btn.disabled = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(r => {
        if (!r.ok) {
          return r.json().then(err => { throw new Error(err.description || 'Cart update failed'); });
        }
        // Refresh the page so the line vanishes / quantity updates / totals recalculate
        window.location.reload();
      }).catch(err => {
        if (btn) btn.disabled = false;
        alert(err.message);
      });
    }

    // Remove buttons
    root.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        changeLine(btn.dataset.lineKey, 0, btn);
      });
    });

    // Qty +/- buttons
    root.querySelectorAll('[data-cart-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.lineKey;
        const delta = parseInt(btn.dataset.cartQty, 10);
        const input = root.querySelector('[data-cart-qty-input][data-line-key="' + key + '"]');
        const current = parseInt(input ? input.value : '1', 10);
        const next = Math.max(0, current + delta);
        changeLine(key, next, btn);
      });
    });

    // Qty input direct change (typing a number then tabbing out)
    root.querySelectorAll('[data-cart-qty-input]').forEach(input => {
      input.addEventListener('change', () => {
        const key = input.dataset.lineKey;
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(key, qty, input);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const form = document.querySelector('[data-cgrid-form]');
    if (!form) return;

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], select')) {
        form.submit();
      }
    });

    const priceInputs = form.querySelectorAll('input[type="number"]');
    let priceTimer;
    priceInputs.forEach(input => {
      input.addEventListener('input', () => {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(() => form.submit(), 800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  // Variant picker, gallery sync, quantity stepper
  (function() {
    const root = document.querySelector('[data-pdp]');
    if (!root) return;

    // Product variant data — Shopify gives us a product object via Liquid
    const variantsScript = document.createElement('script');
    variantsScript.type = 'application/json';
    variantsScript.id = 'pdp-variants-' + root.dataset.productId;

    // Inject variants JSON via separate script tag (simpler than parsing window globals)
    if (!document.getElementById(variantsScript.id)) {
      // We'll fetch it from window.__pdpVariants which we set below
    }

    const productJson = window.__pdpProduct;
    if (!productJson) return;

    const variants = productJson.variants;
    const formatMoney = (cents) => {
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    // ===== Variant selection =====
    const optionInputs = root.querySelectorAll('[data-pdp-option]');
    const variantIdInput = root.querySelector('[data-pdp-variant-id]');
    const priceEl = root.querySelector('[data-pdp-price]');
    const compareEl = root.querySelector('[data-pdp-compare-at]');
    const priceRow = root.querySelector('[data-pdp-price-row]');
    const addBtn = root.querySelector('[data-pdp-add]');
    const addLabel = root.querySelector('[data-pdp-add-label]');
    const skuEl = root.querySelector('[data-pdp-sku]');
    const stockEl = root.querySelector('[data-pdp-stock]');
    const mainImg = root.querySelector('[data-pdp-main-img]');
    const optionValueEls = root.querySelectorAll('[data-pdp-option-value]');

    function getSelectedOptions() {
      const opts = {};
      optionInputs.forEach(input => {
        if (input.checked) {
          opts[input.dataset.optionPosition] = input.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(v => {
        return Object.keys(opts).every(pos => {
          const optKey = 'option' + pos;
          return v[optKey] === opts[pos];
        });
      });
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);

      // Update displayed option labels
      optionValueEls.forEach(el => {
        const pos = el.dataset.pdpOptionValue;
        if (opts[pos]) el.textContent = opts[pos];
      });

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
        }
        return;
      }

      // Variant ID
      if (variantIdInput) variantIdInput.value = variant.id;

      // URL update
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Price
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.querySelector('s').textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Add button
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      }

      // SKU
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;

      // Featured image swap (if variant has its own image)
      if (variant.featured_image && mainImg) {
        const newSrc = variant.featured_image.src;
        if (newSrc && mainImg.src.indexOf(newSrc.split('?')[0].split('/').pop()) === -1) {
          mainImg.src = newSrc.startsWith('//') ? 'https:' + newSrc : newSrc;
          mainImg.removeAttribute('srcset');
        }
      }
    }

    optionInputs.forEach(input => {
      input.addEventListener('change', updateVariant);
    });

    // ===== Thumbnail click =====
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.imageSrc;
          mainImg.srcset = thumb.dataset.imageSrcset;
        }
      });
    });

    // ===== Quantity stepper =====
    const qtyInput = root.querySelector('[data-pdp-qty-input]');
    const qtyBtns = root.querySelectorAll('[data-pdp-qty]');
    qtyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const delta = parseInt(btn.dataset.pdpQty, 10);
        const current = parseInt(qtyInput.value, 10) || 1;
        const next = Math.max(1, current + delta);
        qtyInput.value = next;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
